import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-confirmation-dialog.const';
import { CONFIGURATION_MIGRATION_PERSONAL_KEY, CONFIGURATION_MIGRATION_GENERAL_KEY } from './publish-button-service.const';

// Private

const getWorkflowFlag = async (title) =>
	(await AppDialogManagerService.openConfirmationDialog({
		title,
		yesText: 'Yes',
		noText: 'No',
		isDanger: false,
	})) === APP_CONFIRMATION_DIALOG_RESPONSES.YES;
const getWorkflowInstallableFlag = () => getWorkflowFlag('Do you want to publish an installable version?');
const getMigrateValuesForConfiguration = (configurationType, publishedVersionHasConfiguration, workflowIsShared, workflow) =>
	AppDialogManagerService.openConfigurationsMigrationDialog({
		configurationType,
		publishedVersionHasConfiguration,
		workflowIsShared,
		workflow,
	});
const getMigrateValuesForGeneralConfiguration = (publishedVersionHasConfiguration, workflow) =>
	getMigrateValuesForConfiguration(CONFIGURATION_MIGRATION_GENERAL_KEY, publishedVersionHasConfiguration, false, workflow);
const getMigrateValuesForPersonalConfiguration = (publishedVersionHasConfiguration, workflowIsShared, workflow) =>
	getMigrateValuesForConfiguration(CONFIGURATION_MIGRATION_PERSONAL_KEY, publishedVersionHasConfiguration, workflowIsShared, workflow);

// Public

const getWorkflowPublishFlags = async ({
	workflowHasInstallable,
	workflowHasGeneralConfigurations,
	workflowHasPersonalConfigurations,
	fetchSharedData,
	getWorkflowSharedData,
	isConfigurationsOn,
	isInstallablesOn,
	publishedWorkflowVersionHasGeneralConfigurations,
	publishedWorkflowVersionHasPersonalConfigurations,
	workflowIsPublished,
	workflow,
}) => {
	const workflowHasConfigurations = workflowHasGeneralConfigurations || workflowHasPersonalConfigurations;
	const flags = {};
	if (workflowHasInstallable && isInstallablesOn) {
		flags.create_new_installable_version = await getWorkflowInstallableFlag();
	}
	if (workflowHasConfigurations && isConfigurationsOn) {
		// fetch and wait for shared data only if needed
		const sharedDataPromise =
			workflowIsPublished && workflowHasPersonalConfigurations ? fetchSharedData({ force: true }) : new Promise((resolve) => resolve());
		if (workflowHasGeneralConfigurations) {
			const { publisherHandler: generalConfiguration } = await getMigrateValuesForGeneralConfiguration(
				publishedWorkflowVersionHasGeneralConfigurations,
				workflow
			);
			Object.assign(flags, { handle_general_configuration_response: generalConfiguration });
		}
		if (workflowHasPersonalConfigurations) {
			await sharedDataPromise;
			const workflowIsShared = getWorkflowSharedData();
			const { allUsersHandler: allUsersPersonalConfiguration, publisherHandler: publisherPersonalConfiguration } =
				await getMigrateValuesForPersonalConfiguration(publishedWorkflowVersionHasPersonalConfigurations, workflowIsShared, workflow);
			Object.assign(flags, {
				handle_publisher_personal_configuration_response: publisherPersonalConfiguration,
				handle_all_users_personal_configuration_response: allUsersPersonalConfiguration,
			});
		}
	}
	return flags;
};

const PublicButtonService = {
	getWorkflowPublishFlags,
};

export default PublicButtonService;
